<template>
  <b-row
    :class="`row-container tw-flex tw-flex-row tw-gap-[40px] tw-mr-0 tw-ml-0 tw-flex-wrap tw-justify-between tw-items-center`"
  >
    <b-col :class="['tw-pr-0 tw-pl-0 tw-flex tw-item-center']">
      <div
        :class="`tw-text-[#231F20] tw-text-[14px] tw-not-italic tw-font-medium tw-leading-[145%] ${
          required ? 'question' : 'tw-relative'
        }`"
      >
        <span>{{ title }}</span>
        <span v-if="notOptional" class="tw-text-[red]">&nbsp;*</span>
      </div></b-col
    >
    <b-col :class="'col-sm-6 tw-pr-0 tw-pl-0'">
      <MutliLevelMutliSelectDropdown
        v-model="value"
        :data="dropdownData || []"
        :type="type"
        :time-updated="timeUpdated"
        :enable-search="type === DROPDOWN_TYPE.MULTIPLE"
        :placeholder="placeholder"
        :search-placeholder="searchPlaceholder"
        :main-wrapper-class="`${
          validation?.$errors[0] ? 'is-invalid-input' : ''
        } ${
          isApiError
            ? '!tw-border-[red] tw-border-[1px] tw-border-solid tw-rounded-[6px]'
            : ''
        }`"
        data-cy-id="wizard-multi-level-multi-select-question"
        @update:store="() => emit('update:store')"
        @update:model-value="
          (value, data) => {
            emit('update:modelValue', value, data);
          }
        "
      />
      <div>
        <slot name="feedback">
          <b-form-invalid-feedback
            :class="{ 'is-invalid': validation?.$error }"
          >
            <VRuntimeTemplate :template="validation?.$errors?.[0]?.$message" />
          </b-form-invalid-feedback>
        </slot>
      </div>
    </b-col>
  </b-row>
</template>

<script setup lang="ts">
import { DROPDOWN_TYPE } from "@/utils/constants";
import MutliLevelMutliSelectDropdown from "../common/mutliLevelMutliSelectDropdown/mutliLevelMutliSelectDropdown.vue";
import { PropType, computed, ref } from "vue";
import { IMultiSelectDropdown } from "@/interfaces/common/IDropDown";
import VRuntimeTemplate from "vue3-runtime-template";

const props = defineProps({
  modelValue: {
    type: String,
    required: false,
    default: "",
  },
  title: {
    type: String,
    required: true,
  },
  required: {
    type: Boolean,
    default: false,
  },
  answer: {
    type: Number,
    default: null,
  },
  dropdownData: {
    type: Object as PropType<IMultiSelectDropdown[]>,
    default: () => [] as IMultiSelectDropdown[],
  },
  type: {
    type: String,
    required: false,
    default: DROPDOWN_TYPE.MULTIPLE,
  },
  placeholder: {
    type: String,
    required: false,
    default: "",
  },
  searchPlaceholder: {
    type: String,
    required: false,
    default: "",
  },
  validation: {
    type: Object,
    required: false,
    default: null,
  },
  timeUpdated: {
    type: String,
    required: false,
    default: "false",
  },
  notOptional: {
    type: Boolean,
    default: false,
  },
  isApiError: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits([
  /** Event on value update */
  "update:modelValue",
  "update:store",
]);

const value = computed({
  get() {
    return props.modelValue;
  },
  set(value) {},
});
</script>

<style scoped>
.question {
  position: relative;
}
.question::after {
  content: "*";
  position: relative;
  right: -4px;
  top: -2px;
  color: #f7553c;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%;
}

.is-invalid-input {
  border: 1px solid #f7553c;
  background: #fee5e2;
  border-radius: 6px;
  &::after {
    content: "";
  }
}
@media screen and (max-width: 600px) {
  .row-container {
    flex-direction: column;
    gap: 20px;

    .col-sm-6 {
      max-width: 100%;
    }
  }
  .col-container {
    display: none;
  }
  /* .invalid-feedback {
    margin-left: 15px;
  } */
}
</style>
